export default __webpack_public_path__ + "static/media/husan.d1d69a9e.png";